import styled from 'styled-components/macro';
import { FlexContainer } from '../../../../components/flex';

export const EventsContainer = styled(FlexContainer)`
  min-height: 18rem;
`;
